import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import DashboardCentralisedServiceNew from "./CentralisedService/DashboardCentralisedService-New";
import CSClientClose from "./CentralisedService/CSClientClose";

// Not sure about these two
import { LayoutSplashScreen } from "../../../_metronic";

// Admin Pages
import ProfileCentralisedService from "./CentralisedService/ProfileCentralisedService";
import CsClients from "./CentralisedService/CSClients";
import CsAgents from "./CentralisedService/CsAgents";
import CsCentres from "./CentralisedService/CsCentres";
import CsProviderList from "./CentralisedService/CSProviderList";
import CsClientRegistration from "./CentralisedService/CSClientRegistration";
import HowToArticles from "./KnowledgeBase/HowToArticles";
import Resources from "./KnowledgeBase/Resources";
import Policies from "./KnowledgeBase/Policies";

// Reference Pages
// import UserRoles from "./reference/UserRoles";

export default function HomePageCentralisedService() {
  const login = useSelector((state) => state.auth.csAgentID);
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <Route path="/dashboard" component={DashboardCentralisedServiceNew} />
        <Route path="/csclients" component={CsClients} />

        {/* Admin Pages */}
        <Route path="/profile" component={ProfileCentralisedService} />
        <Route path="/csagents" component={CsAgents} />
        <Route path="/csproviderlist" component={CsProviderList} />
        <Route path="/cscentres" component={CsCentres} />
        <Route path="/csclientregistration" component={CsClientRegistration} />
        <Route path="/csclientclose" component={CSClientClose} />
        {/* Knowledge Base Pages */}
        <Route path="/howtoarticles" component={HowToArticles} />
        <Route path="/resources" component={Resources} />
        <Route path="/policies" component={Policies} />
        {/* Reference Pages */}
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
